import { render, staticRenderFns } from "./selectProject.vue?vue&type=template&id=d81e9fd4&scoped=true"
import script from "./selectProject.vue?vue&type=script&lang=js"
export * from "./selectProject.vue?vue&type=script&lang=js"
import style0 from "./selectProject.vue?vue&type=style&index=0&id=d81e9fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81e9fd4",
  null
  
)

export default component.exports